import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faLinkedin,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import logo from "../../assets/Images/White_TCL_logo.png";
import ELLIPSE from "../../assets/Images/Ellipse 4010.png";
import "./Footer.css";
const Footer = () => {
  return (
    <div
      className="container-fluid"
      style={{ backgroundColor: "#000000", color: "#FFFFFF" }}
    >
      {/* <div className="headline-wrapper">
        <div className="headline-track">
          <div className="headline-item-with-icon">
            <span className="headline-item">Travellers Choice Ladakh</span>
            <img src={ELLIPSE} alt="ellipse" className="rotating-icon" />
          </div>
          <div className="headline-item-with-icon">
            <span className="headline-item">
              Explore Ladakh Like Never Before
            </span>
            <img src={ELLIPSE} alt="ellipse" className="rotating-icon" />
          </div>
          <div className="headline-item-with-icon">
            <span className="headline-item">Your Adventure Starts Here</span>
            <img src={ELLIPSE} alt="ellipse" className="rotating-icon" />
          </div>
          <div className="headline-item-with-icon">
            <span className="headline-item">Travellers Choice Ladakh</span>
            <img src={ELLIPSE} alt="ellipse" className="rotating-icon" />
          </div>
          <div className="headline-item-with-icon">
            <span className="headline-item">
              Explore Ladakh Like Never Before
            </span>
            <img src={ELLIPSE} alt="ellipse" className="rotating-icon" />
          </div>
          <div className="headline-item-with-icon">
            <span className="headline-item">Your Adventure Starts Here</span>
            <img src={ELLIPSE} alt="ellipse" className="rotating-icon" />
          </div>
        </div>
      </div> */}
      <div className="row p-sm-5 p-4">
        {/* Left Column */}
        <div className="col-lg-5 pt-4 pe-4">
          <h3 className="mb-4 d-flex align-items-center">
            <img
              src={logo}
              alt="Logo"
              style={{ marginRight: "10px" }}
              width="185"
            />
          </h3>
          <p className="mb-4 fs-14">
            Craft your Ladakh story with seamless journeys, vibrant culture, and
            stunning mountain adventures await.
          </p>
        </div>

        {/* Right Column */}
        <div className="col-lg-7 pt-4">
          <div className="row">
            {/* Column 1 */}
            <div className="col-12 col-md-4">
              <ul
                className="mt-4 fs-14"
                style={{ listStyleType: "none", paddingLeft: "0" }}
              >
                {/* <li className="mb-4">
                  <Link to="/plan-ladakh-trip" style={{ color: "#FFFFFF", textDecoration: "none" }}>
                    Help me plan my trip
                  </Link>
                </li> */}
                <li className="mb-4">
                  <button
                    style={{
                      color: "#FFFFFF",
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                    }}
                    onClick={() => {
      window.open("https://travellerchoiceladakh.com/blog/", "_blank");
    }}

                    
                  >
                    Blog
                  </button>
                </li>
                <li className="mb-4">
                  <Link
                    to="/contact-us"
                    style={{ color: "#FFFFFF", textDecoration: "none" }}
                  >
                    Contact Us
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/all-destinations"
                    style={{ color: "#FFFFFF", textDecoration: "none" }}
                  >
                    Destinations
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 2 */}
            <div className="col-12 col-md-4">
              <ul
                className="mt-4 fs-14"
                style={{
                  listStyleType: "none",
                  paddingLeft: "0",
                  textDecoration: "none",
                }}
              >
                <li className="mb-4">
                  <Link
                    to="/HotelPackage"
                    className=" text-white text-decoration-none"
                  >
                    Ladakh Hotel Booking
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/BikePackage"
                    className="link-style text-white text-decoration-none"
                  >
                    Bike Trip
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to="/CarPackage"
                    className="link-style text-white text-decoration-none"
                  >
                    Ladakh Car & Tour Package
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3 - Social */}
            <div className="col-12 col-md-4">
              <p className="mt-4">Follow Us</p>
              <ul
                className="d-flex gap-4 fs-14"
                style={{
                  listStyleType: "none",
                  paddingLeft: 0,
                  marginBottom: 0,
                }}
              >
                <li>
                  <Link
                    to="https://www.facebook.com/profile.php?id=100088895292951&mibextid=ZbWKwL"
                    className="text-white"
                    style={{ textDecoration: "none" }}
                  >
                    <FontAwesomeIcon icon={faFacebook} size="lg" />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.instagram.com/travellers_choice_ladakh/"
                    className="text-white"
                    style={{ textDecoration: "none" }}
                  >
                    <FontAwesomeIcon icon={faInstagram} size="lg" />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://youtube.com/@TRAVELLERSCHOICE-ll2kl?si=EX6n-jYw7HA-1oK3"
                    className="text-white"
                    style={{ textDecoration: "none" }}
                  >
                    <FontAwesomeIcon icon={faYoutube} size="lg" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div
        className="mt-2 mb-2"
        style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.5)" }}
      ></div>

      {/* Bottom Footer Links */}
      <div className="row mt-1">
        <div className="col-lg-8 ps-4 fs-14">
          <p>© 2026 TravellerChoiceLadakh.com. All Rights Reserved.</p>
        </div>
        <div className="col-lg-4 d-flex justify-content-between fs-14">
          <ul
            className="flex-wrap"
            style={{ listStyleType: "none", display: "flex", gap: "30px" }}
          >
            <li>
              <Link
                to="/cancellation-policy"
                className="text-white text-decoration-none"
              >
                Cancellation Policy
              </Link>
            </li>
            <li>
              <Link
                to="/privacy-policy"
                className="text-white text-decoration-none"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to="/terms-and-condition"
                className="text-white text-decoration-none"
              >
                Terms of Use
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
export default Footer;
